import React, {FC} from 'react'
import {ErrorBoundary} from 'react-error-boundary'

import {Grid, GridSize, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {ErrorBoundaryFallback} from '@progyny/components/ErrorBoundary'
import {SubpageHeader} from '@progyny/pages/Profile/fragments/header'

type Props = {
  title: string
  lgSize?: GridSize
}
const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    marginTop: theme.spacing(4),
  },
}))

export const SubpageOneColGrid: FC<React.PropsWithChildren<Props>> = ({
  title,
  lgSize = 5,
  children,
}) => {
  const {classes} = useStyles()

  return (
    <ErrorBoundary fallbackRender={ErrorBoundaryFallback}>
      <Grid container className={classes.container}>
        <Grid item xs={12} sm={7} lg={lgSize}>
          <SubpageHeader title={title} />
          {children}
        </Grid>
      </Grid>
    </ErrorBoundary>
  )
}

// TODO: Define the 2-col grid of personal-info if we need more of those pages
